import React from 'react';
import _ from 'lodash';
import { Typography } from 'antd';
import ModalStatusMessage from '../../components/typograhpy/ModalStatusMessage';
import ManualFormStepCustomer from '../../components/forms/manualBooking/ManualFormStepCustomer';
import LoadingSpinner from '../../components/LoadingSpinner';
import { withFormHandler } from '../providers/ManualBookingFormHandler';


const { Title } = Typography;

const ManualBookingForm = props => {
    const {
        isComplete,
        hasError,
        isLoading,
        submitForm,
        handleCancel,
    } = props;

    if (hasError) {
        return (
            <ModalStatusMessage
                variant="error"
                message={_.get(props, 'errorMessage', 'There was an error processing this request.')}
                handleClose={handleCancel}
            />
        );
    }

    if (isComplete) {
        return (
            <ModalStatusMessage
                variant="success"
                message="Successfully created booking."
                handleClose={handleCancel}
            />
        );
    }

    if (isLoading) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <Title level={4}>
                Create a manual booking:
            </Title>
            <br />
            <ManualFormStepCustomer submitStep={submitForm} />
        </>
    );
};

export default withFormHandler(ManualBookingForm);
